module.exports = __webpack_public_path__ + "img/four4Green.44c4f736.jpg";